export default  {"src":"/_next/static/image/public/assets/nevo-boi/chevron-up.c8222369eaaf3ada760f7bda09d914fd.svg","height":22,"width":22};